import { Breadcrumb } from '@components/breadcrumb';
import { useEffect, useMemo, useRef } from 'react';
import { useFragment } from 'react-relay';
import AppEventEmitter, { events as AppEventEmitterEvents } from '../../utils/appEventEmitter';
import { TypeMap, sectionPageFragment } from './lib';
import type { SectionPageProps } from './types';

export const SectionPage: React.FC<SectionPageProps> = (props) => {
  const { location, userCountry, salesAdmission, onChangeSalesAdmission } = props;
  const page = useFragment(sectionPageFragment, props.page);

  // Compute section navigation - memoized to avoid recalculation
  const sectionNavigation = useMemo(() => {
    return page.sections.map((section) => ({
      navigationTitle: section.navigationTitle,
      anchorName: section.anchorName,
    }));
  }, [page.sections]);

  // Track if this is the first render for componentDidUpdate equivalent
  const isFirstRender = useRef(true);

  // Replace componentDidUpdate - emit header change event when sections change
  useEffect(() => {
    // Skip first render (componentDidUpdate doesn't run on mount)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (page.sections?.[0]) {
      AppEventEmitter.emit(AppEventEmitterEvents.HEADER_CHANGE_IMAGE, page.sections[0].titleImageUrl, page.sections[0].titleImageBackgroundUrl);
    }
  }, [page.sections]);

  return (
    <div className="SectionPage">
      <Breadcrumb data={page.breadcrumbs} />
      {page.sections.map((section, index) => {
        const PageSection = TypeMap[section.__typename];

        if (!PageSection) {
          console.warn(`[SectionPage] Unknown section type: ${section.__typename}`);
          return null;
        }

        return (
          <PageSection
            key={section.__typename}
            pageSection={section}
            sectionNavigation={sectionNavigation}
            showImage={index !== 0}
            index={index}
            location={location}
            userCountry={userCountry}
            salesAdmission={salesAdmission}
            onChangeSalesAdmission={onChangeSalesAdmission}
          />
        );
      })}
    </div>
  );
};
